import React from 'react';

// components
import CommonForm from "../Common/CommonForm";
import BaseApi from "../../utils/BaseApi";
import ChecklistQuestionCreate from "./ChecklistQuestionCreate";
import {CircularProgress, Stack} from "@mui/joy";
import {deleteArrayItemByKeyValue} from "../../utils/misc";


class ChecklistTypeQuestionCreateInner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formFields: null,
        };
    }

    async componentDidMount() {
        await this.retrieveFields()
    }

    async retrieveFields(){
        this.setState({
            formFields: null,
        })
        const url = `checklist_type_question/create_form/`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        let formFields = response.data
        formFields = deleteArrayItemByKeyValue(
            formFields,
            'name',
            'type'
        );
        this.setState({
            formFields: formFields,
        })
    }

    async processForm(form) {
        let formDataObj = Object.fromEntries(
            form.state.formData.entries()
        );
        formDataObj.type = this.props.checklistType.id
        const url = `checklist_type_question/`;
        const api = new BaseApi();
        let response = await api.post(
            url,
            formDataObj
        );
        if (response.status === 201) {
            if (typeof this.props.callBack == 'function') {
                await this.props.callBack();
            }
        }
        return response
    }

    render(){
        if (!this.state.formFields) {
            return (<CircularProgress/>)
        }
        return(
            <Stack
                spacing={2}
            >
                <ChecklistQuestionCreate
                    title={'Добавить вопрос'}
                    color={'warning'}
                    callBack={this.retrieveFields.bind(this)}
                />
                <CommonForm
                    fields={this.state.formFields}
                    processForm={this.processForm.bind(this)}
                />
            </Stack>
        )
    }
}

export default ChecklistTypeQuestionCreateInner
